require('../passwordResetService');

angular.module('app.passwordReset.passwordResetSave.passwordResetSaveController', [
  'app.passwordReset.passwordResetService'
])
  .controller('app.passwordReset.passwordResetSave.passwordResetSaveController', [
    '$scope',
    '$stateParams',
    'app.passwordReset.passwordResetService',
    '$state',
    function ($scope, $stateParams, passwordReset, $state) {
      "use strict";

      $scope.user = null;
      $scope.new_password = null;
      $scope.confirm_password = null;
      $scope.error = null;
      $scope.passwordPass = false;

      let init = function () {
        passwordReset.getUserByToken($stateParams.token)
          .then(
            function (response) {
              $scope.user = response.data;
            }
          );
      };

      $scope.savePassword = function () {
        if ($scope.new_password === $scope.confirm_password) {
          if ($scope.passwordPass) {
            passwordReset.savePassword($scope.user.login_name, $scope.new_password, $stateParams.token)
              .then(
                function (response) {
                  let data = response.data;
                  if (data.error) {
                    $scope.error = data.error;
                  }
                  else {
                    $state.go('app.login');
                  }
                }
              );
          }
          else {
            $scope.error = 'Password is too easy to guess'
          }
        }
        else {
          $scope.error = 'Passwords do not match';
        }
      };

      init();
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/passwordReset/passwordResetSave/passwordResetSaveController.js